import axios from "axios";
import {log} from "../utils/logger";

export const getTweetsByParameters = async (parameters) => {
  try {
    return await axios.get(`${process.env.GATSBY_WS_API_URL}/twitter/stream`, {
      params: parameters,
    });
  } catch (error) {
    throw ("error api tweets", error);
  }
};

export const getLastYoutubeVideosByParameters = async (parameters) => {
  try {
    return await axios.get(`${process.env.GATSBY_WS_API_URL}/youtube/stream?`, {
      params: parameters,
    });
  } catch (error) {
    throw ("error api youtube", error);
  }
};

const toUrl = (url) => {
  if (url && url.indexOf('youtube') !== -1) {
    if (url.indexOf('shorts') !== -1) {
      const vv = url.split('/')
      return `https://www.youtube.com/watch?v=${vv[vv.length - 1]}`
    }
  }
  return url
}


export const getContentByUrl = async (url) => {
  try {
    return await axios.get(`${process.env.GATSBY_WS_API_URL}/oembed?`, {
      params: { uri: toUrl(url) }
    })
  } catch (error) {
    log(error);
    // let json = `{"type":"video","version":"1.0","title":"Le parlophone magique pour rater l’école","authorName":"Smilyfritman ","authorUrl":"https://www.youtube.com/@Smily-en-shorts","providerName":"YouTube","providerUrl":"https://www.youtube.com/","thumbnailUrl":"https://i.ytimg.com/vi/yuDHCp6Dx50/hqdefault.jpg","thumbnailWidth":480,"thumbnailHeight":360,"html":"<iframe width=\\"200\\" height=\\"113\\" src=\\"https://www.youtube.com/embed/yuDHCp6Dx50?feature=oembed\\" frameborder=\\"0\\" allow=\\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\\" allowfullscreen title=\\"Le parlophone magique pour rater l’école\\"></iframe>","width":200,"height":113}`
    // return {data: JSON.parse(json)} // test en local
  }
};
